<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-autocomplete label="Selecionar Unidade" :items="listOfEnderecos" v-model="enderecoSelecionado" clearable></v-autocomplete>

    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false && showDatatable"
      :tableTitle="'Dispensa de Setores'"
      :tableHeader="headers"
      :tableRows="listOfDispensasDeSetores"
      :isView="false"
      :isEdit="true"
      :isFinish="false"
      :isDevolucao="true"
      :isPrint="false"
      :totalItens="totalDispensa"
      v-on:datatable-updaterow="updateDispensaSetor"
      v-on:datatable-devolucao="modalDeletar"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == false" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="update"
    >
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-col cols="12">
            <v-autocomplete label="Lista de Setores" :items="listOfSetores" v-model="setorSelecionado" :rules="[rules.required]" disabled></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line></v-text-field>
              </v-card-title>

              <v-data-table v-if="!dispensaAntiga" :headers="headersItensDispensados" :search="search" :items="modalCustomSize.actualEdit.listaDeItensEnviados" disable-sort>
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.validade`]="{ item }">
                  <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
                </template>

                <template v-slot:[`item.item.validade`]="{ item }">
                  <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
                </template>

                <template v-slot:[`item.itemDispensa.quantidadeDispensada`]="props">
                  <v-text-field style="max-width:250px" v-model="props.item.itemDispensa.quantidadeDispensada" :rules="[rules.required]" label="Quantidade para Dispensar" single-line @keypress="(event) => filter(event)"></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small @click="deleteItemFromList(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <DataTable v-if="dispensaAntiga" :tableTitle="'Produtos Dispensados para o setor: ' + modalCustomSize.actualEdit.nomeSetor" :tableHeader="headersItensDispensadosAntigo" :tableRows="modalCustomSize.actualEdit.listaDeItensEnviados"></DataTable>
            </v-card>
          </v-col>
        </v-row>
      </v-form>

      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </ModalCustomSize>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <DeleteItemModal :showModalDelete="modalDelete.abrir" :textModalDelete="modalDelete.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="deleteDispensa"></DeleteItemModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import axios from "../plugins/axios";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    DeleteItemModal,
    Alertas,
    AlertasModal,
    AlertaSnackbar,
  },


  data: () => ({
    //Paginação
    pageDispensa: 1,
    searchDispensa: null,
    totalDispensa: null,
    //Fim da paginação
    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},

    rules: {
      required: (value) => !!value || "Requer o campo!",
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    modalDelete: {
      abrir: false,
      texto: "Deseja realmente devolver essa Dispensa de Setor?",
      actualEdit: {
        dispensaSetorSelecionado: null,
        listaDeItens: [],
      },
    },

    search: "",
    showDatatable: false,
    showSkeletonTable: true,
    loading: false,
    showTextField: false,
    isFormValid: false,
    dispensaAntiga: false,

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    headers: [
      {
        text: "ID",
        value: "numeroDispensaSetor",
      },
      {
        text: "Nome Setor",
        value: "nomeSetor",
      },
      {
        text: "Nome Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Dispensa",
        value: "funcionario.nomeFuncionario",
      },
      {
        text: "Data Dispensa",
        value: "dataDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensados: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensa",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Qt. Atual",
        value: "itemUnidade.quantidadeEstoque",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensadosAntigo: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensa",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
    ],

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        descricaoTela: "dispensaDeSetores",
        numeroSetor: null,
        numeroDispensaSetor: null,
        numeroEndereco: null,
        numeroFuncionario: null,
        nomeSetor: null,
        nomeUnidade: null,
        nomeResponsavelUnidade: null,
        nomeFuncionario: null,
        dataDispensa: null,
        quantidadeRecebidaItem: null,
        listaDeItensEnviados: [],
        listaDeItensExcluidos: [],
      },
    },

    //Array populado pela função initialize
    listOfDispensasDeSetores: [],
    listOfEnderecos: [],
    listOfSetores: [],
    listOfItensByUnidade: [],

    enderecoSelecionado: null,
    setorSelecionado: null,
    itemSelecionado: null,
  }),

  created() {
    this.initialize();
  },

  watch: {
    enderecoSelecionado() {
      if (this.enderecoSelecionado) {
        this.modalCustomSize.actualEdit.numeroEndereco = this.enderecoSelecionado;
        this.showSkeletonTable = true;

        this.returnlistOfDispensasDeSetores();
        this.showDatatable = true;
      } else {
        this.showSkeletonTable = false;
        this.showDatatable = false;
      }
    },

    setorSelecionado() {
      this.modalCustomSize.actualEdit.numeroSetor = this.setorSelecionado;
    },

    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
  },

  methods: {
    async initialize() {
      try {
        let responseEndereco = await axios.get("enderecoordemservico", this.config);
        this.listOfEnderecos = responseEndereco.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async returnlistOfDispensasDeSetores() {
      try {
        let listDispensa = await axios.put("dispensaSetor", { numeroEndereco: this.enderecoSelecionado, page: this.pageDispensa, search: this.searchDispensa }, this.config);
        if (!listDispensa.data || listDispensa.data.length > 0) {
          this.listOfDispensasDeSetores = listDispensa.data;
          this.totalDispensa = listDispensa.data[0].total;
        }
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.showSkeletonTable = false;
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.searchDispensa = search;
        this.pageDispensa = 1;
        await this.returnlistOfDispensasDeSetores();
      } else {
        this.pageDispensa = 1;
      }
    },

    async updatePage(pagination) {
      this.pageDispensa = pagination.page;
      await this.returnlistOfDispensasDeSetores();
    },

    async recoverListOfSetores() {
      try {
        let responseSetor = await axios.put("setorUnidade", { numeroEndereco: this.enderecoSelecionado }, this.config);

        this.listOfSetores = responseSetor.data.map((row) => {
          return {
            value: row.numeroSetor,
            text: row.nomeSetor,
          };
        });
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async update() {
      this.modalCustomSize.isButtonsDisabled = true;
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;

        if (this.modalCustomSize.actualEdit.listaDeItensEnviados.length > 0) {
          await axios.put("dispensaSetorUpdate", this.modalCustomSize.actualEdit, this.config);
          this.$socket.emit("update", this.modalCustomSize.actualEdit);

          this.modalCustomSize.isOpen = false;
          this.modalCustomSize.isLoadingRequestDisable = false;
          this.recoverListOfSetores();
        } else {
          this.modalCustomSize.isButtonsDisabled = false;
          this.modalCustomSize.isLoadingRequestDisable = false;
        }
      } catch (error) {
        console.log(error);
        this.modalCustomSize.isOpen = true;
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    async deleteDispensa() {
      try {
        await axios.delete("dispensaSetor", {
          data: this.modalDelete.actualEdit,
          headers: this.config.headers,
        });

        this.alerta.texto = "Dispensa removida com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalDelete.abrir = false;
        this.returnlistOfDispensasDeSetores();
      }
    },

    async updateDispensaSetor(dispensaSelecionada) {
      this.loading = true;
      try {
        await this.recoverListOfSetores();

        const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: dispensaSelecionada.numeroDispensaSetor }, this.config);
        this.modalCustomSize.actualEdit.listaDeItensEnviados = response.data;

        this.dispensaAntiga = true;
        response.data.map((itemSelecionado) => {
          if (itemSelecionado.itemUnidade) {
            this.dispensaAntiga = false;
          }
        });
        this.modalCustomSize.isButtonsVisible = !this.dispensaAntiga;

        this.search = "";
        this.itemSelecionado = null;
        this.setorSelecionado = dispensaSelecionada.numeroSetor;
        this.modalCustomSize.actualEdit.numeroSetor = this.setorSelecionado;
        this.modalCustomSize.actualEdit.numeroDispensaSetor = dispensaSelecionada.numeroDispensaSetor;
        this.modalCustomSize.actualEdit.nomeSetor = dispensaSelecionada.nomeSetor;
        this.modalCustomSize.actualEdit.numeroEndereco = this.enderecoSelecionado;
        this.modalCustomSize.actualEdit.nomeUnidade = dispensaSelecionada.endereco.nomeEndereco;
        this.modalCustomSize.actualEdit.nomeResponsavelUnidade = dispensaSelecionada.endereco.nomeResponsavel;
        this.modalCustomSize.actualEdit.numeroFuncionario = dispensaSelecionada.funcionario.numeroFuncionario;
        this.modalCustomSize.actualEdit.nomeFuncionario = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.actualEdit.dataDispensa = dispensaSelecionada.dataDispensaSetor;
        this.modalCustomSize.actualEdit.listaDeItensExcluidos = [];
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Visualizar Dispensa do Setor";
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeletar(dispensaSetor) {
      const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: dispensaSetor.numeroDispensaSetor }, this.config);
      this.modalDelete.actualEdit.listaDeItens = response.data;

      this.modalDelete.actualEdit.dispensaSetorSelecionado = dispensaSetor.numeroDispensaSetor;
      this.modalDelete.abrir = true;
    },

    deleteItemFromList(value) {
      this.modalCustomSize.actualEdit.listaDeItensExcluidos.push(this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.itemDispensa.numeroItemDispensa == value.itemDispensa.numeroItemDispensa)[0]);
      this.modalCustomSize.actualEdit.listaDeItensEnviados = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.itemDispensa.numeroItemDispensa != value.itemDispensa.numeroItemDispensa);

      if (this.modalCustomSize.actualEdit.listaDeItensEnviados.length == 0) {
        this.modalCustomSize.isButtonsDisabled = true;
      }
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
